// Эцэг эх (бага анги) — өнөөдөр: хүүхдийн ирц, хүлээлгэн өгсөн эсэх, өдөр өнжүүлэх хүсэлт + QPay төлбөр.
// Хүсэлтийг 16:00 хүртэл хэзээ ч илгээж болно; гэрээгүй бол 50,000₮ (хоолтой) QPay-ээр төлнө.
import React, { useEffect, useState } from "react";
import { Button, Modal, Spin, Tag, message } from "antd";
import { FiSun, FiUserCheck, FiClock, FiCheckCircle, FiRefreshCw } from "react-icons/fi";
import dayjs from "dayjs";
import { instance } from "utils/axios";

const ATT = { Ирсэн: "green", Хоцорсон: "gold", Өвчтэй: "purple", Чөлөөтэй: "blue", Тасалсан: "red" };
const getBase64Img = (b64) => `data:image/png;base64,${b64}`;

export default function DaycareCard({ studentId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(null);
  const [pay, setPay] = useState(null); // хүүхэд (QPay модал)

  const load = () => {
    setLoading(true);
    instance({ method: "get", url: "/student/daycare/today" })
      .then((r) => setData(r.data))
      .catch(() => {})
      .then(() => setLoading(false));
  };
  useEffect(load, []);

  if (!data || !data.children?.length) return null; // бага ангийн хүүхэдгүй бол харуулахгүй
  // Нэг хүүхдийн блок (эцэг эхийн нүүрэнд хүүхдийн карт дотор ордог)
  const only = studentId ? data.children.find((x) => x.id === studentId) : null;
  if (studentId && !only) return null;

  const request = (c) => {
    const fee = c.hasContract ? 0 : data.fee;
    Modal.confirm({
      title: `${c.firstName} — өдөр өнжүүлэх хүсэлт`,
      content: fee
        ? `Өнөөдөр ${data.end} хүртэл өнжүүлнэ. Төлбөр ${Number(fee).toLocaleString()}₮ (хоол орсон) — QPay-ээр төлнө.`
        : `Өнөөдөр ${data.end} хүртэл өнжүүлнэ. Гэрээтэй тул төлбөргүй.`,
      okText: "Хүсэлт илгээх", cancelText: "Болих",
      onOk: () => {
        setBusy(c.id);
        return instance({ method: "post", url: "/student/daycare/request", data: { studentId: c.id }, noMessage: true })
          .then((r) => {
            message.success("Хүсэлт бүртгэгдлээ");
            setData((d) => ({ ...d, children: d.children.map((x) => (x.id === c.id ? r.data : x)) }));
            if (r.data?.daycare?.paymentStatus === "pending") setPay(r.data);
          })
          .catch((e) => message.error(e?.response?.data?.error || "Илгээж чадсангүй"))
          .finally(() => setBusy(null));
      },
    });
  };

  const check = (c) =>
    instance({ method: "get", url: `/student/daycare/check/${c.daycare.id}` })
      .then((r) => {
        if (r.data?.paymentStatus === "paid") { message.success("Төлбөр төлөгдлөө"); setPay(null); load(); }
        else message.info("Төлбөр хараахан ороогүй байна");
      })
      .catch(() => {});

  const fmt = (t) => (t ? dayjs(t).format("HH:mm") : "");

  // Нэг хүүхдийн өнжүүлэх/хүлээлгэн өгсөн хэсэг
  const childBlock = (c, bare) => {
    const d = c.daycare;
    return (
      <div key={c.id} className={bare ? "" : "rounded-xl border border-gray-100 p-3"}>
        {!bare && (
          <div className="flex items-center gap-3">
            <span className="h-11 w-11 rounded-xl bg-primary/10 text-primary font-bold text-lg flex items-center justify-center">{(c.firstName || "?").charAt(0)}</span>
            <div className="flex-1 min-w-0">
              <div className="font-bold truncate">{c.lastName} {c.firstName} <span className="text-gray-400 font-normal text-xs">{c.grade}-р анги</span></div>
              <div className="text-xs text-gray-500">
                {c.attendance ? <Tag color={ATT[c.attendance.status]} className="!mr-1">{c.attendance.status}</Tag> : <span className="text-gray-400">ирц бүртгэгдээгүй</span>}
                {c.hasContract && <Tag color="geekblue">өнжүүлэх гэрээтэй</Tag>}
              </div>
            </div>
          </div>
        )}
        {bare && (
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-semibold flex items-center gap-1.5 text-gray-700">
              <FiSun className="text-amber-500" /> Өдөр өнжүүлэх · {dayjs(data.date).format("MM.DD")}
            </span>
            {c.hasContract && <Tag color="geekblue" className="!mr-0">гэрээтэй</Tag>}
          </div>
        )}
        {(() => (<>
              {d?.pickedUpAt ? (
                <div className="mt-3 flex items-center gap-2 rounded-xl bg-emerald-50 px-3 py-2.5 text-sm text-emerald-800">
                  <FiUserCheck /> <span><b>{d.pickedUpByLabel}</b>{d.pickedUpByName ? ` (${d.pickedUpByName})` : ""} {fmt(d.pickedUpAt)}-д хүлээж авсан</span>
                </div>
              ) : d?.requested ? (
                <div className="mt-3 rounded-xl bg-amber-50 px-3 py-2.5 text-sm text-amber-800">
                  <div className="flex items-center gap-2"><FiClock /> Өдөр өнжүүлнэ — {data.end} хүртэл <span className="text-xs opacity-70">(хүсэлт {fmt(d.requestedAt)})</span></div>
                  {d.paymentStatus === "pending" && (
                    <div className="mt-2 flex items-center gap-2 flex-wrap">
                      <Tag color="red" className="!mr-0">Төлбөр төлөөгүй · {Number(d.fee).toLocaleString()}₮</Tag>
                      <Button size="small" type="primary" onClick={() => setPay(c)}>QPay-ээр төлөх</Button>
                      <Button size="small" onClick={() => check(c)}>Шалгах</Button>
                    </div>
                  )}
                  {d.paymentStatus === "paid" && <div className="mt-1.5 text-xs flex items-center gap-1 text-emerald-700"><FiCheckCircle /> Төлбөр төлөгдсөн {d.paymentMethod === "cash" ? "(бэлнээр)" : ""}</div>}
                </div>
              ) : (
                <div className="mt-3">
                  <Button type="primary" size="large" block loading={busy === c.id} disabled={!c.canRequest} onClick={() => request(c)}>
                    Өдөр өнжүүлэх хүсэлт{!c.hasContract ? ` · ${Number(data.fee).toLocaleString()}₮` : ""}
                  </Button>
                  <div className="text-[11px] text-gray-400 text-center mt-1.5">
                    {c.canRequest ? `${data.deadline} хүртэл илгээж болно · ${data.end} хүртэл өнжүүлнэ` : c.requestBlockReason || ""}
                  </div>
                </div>
              )}
        </>))()}
      </div>
    );
  };

  // QPay төлбөрийн модал (хоёр хувилбарт хамтдаа)
  const payModal = (
    <>
      {/* QPay төлбөр */}
    <Modal open={!!pay} onCancel={() => setPay(null)} footer={null} centered title={pay ? `${pay.firstName} — өдөр өнжүүлэх ${Number(pay.daycare?.fee || 0).toLocaleString()}₮` : ""} destroyOnClose>
      {pay?.daycare?.qpay ? (
        <div className="flex flex-col items-center">
          <img src={getBase64Img(pay.daycare.qpay.qr_image)} alt="QPay QR" className="w-56 h-56" />
          <div className="text-xs text-gray-500 mt-1">QR-ийг банкны аппаар уншуулна, эсвэл:</div>
          <div className="grid grid-cols-4 gap-2 mt-3 w-full">
            {(pay.daycare.qpay.urls || []).map((u, i) => (
              <button key={i} onClick={() => window.open(u.link)} className="rounded-xl border border-gray-100 p-2 flex flex-col items-center gap-1">
                <img src={u.logo} alt={u.name} className="h-10 w-10 rounded-lg object-contain" />
                <span className="text-[10px] text-gray-500 truncate w-full text-center">{u.name}</span>
              </button>
            ))}
          </div>
          <Button type="primary" size="large" block className="mt-4" onClick={() => check(pay)}>Төлбөр шалгах</Button>
        </div>
      ) : <div className="flex justify-center py-6"><Spin /></div>}
    </Modal>
    </>
  );

  // ── Хүүхдийн карт дотор (нэг хүүхэд, нэр давтахгүй) ──
  if (studentId) {
    return (
      <div className="p-4 border-b border-gray-50">
        {childBlock(only, true)}
        {payModal}
      </div>
    );
  }

  return (
    <section className="pcard pcard-pad">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-bold flex items-center gap-2"><FiSun className="text-amber-500" /> Өнөөдөр · {dayjs(data.date).format("MM.DD")}</h2>
        <button onClick={load} className="text-gray-400 p-1"><FiRefreshCw className={loading ? "animate-spin" : ""} /></button>
      </div>
      <div className="flex flex-col gap-3">
        {data.children.map((c) => childBlock(c, false))}
      </div>

      {payModal}
    </section>
  );
}
